<template>
<v-card class="">
  <v-card-actions class="" style="background-color:#707070;color:white; height:40px;">
    並び替え設定
    <v-spacer></v-spacer>
    <v-icon color="white" @click="$emit('close',false)">mdi-close</v-icon>
  </v-card-actions>
  <v-radio-group column mandatory class="px-6" v-if="idea_slider">
    <v-radio
      v-for="box in checkboxes1"
      :value="box.value"
      :key="box.value"
      @change="onChange(box.value);"
      :label="box.text"
      color="deepAqua"

    ></v-radio>
  </v-radio-group>
  <v-radio-group column mandatory class="px-6" v-else>
    <v-radio
      v-for="box in checkboxes"
      :value="box.value"
      :key="box.value"
      @change="onChange(box.value);"
      :label="box.text"
      color="deepAqua"
    ></v-radio>
  </v-radio-group>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="deepAqua white--text" @click="$emit('close',false)">閉じる</v-btn>
    <v-spacer></v-spacer>
  </v-card-actions>
</v-card>
</template>


<script>
export default {
  name: "IdeaSort",
  props: ['ideaList', 'modifiedLikesCounts'],
  data() {
    return {
      checkboxState: {
        newOrder: true,
        oldOrder: false,
        whoOrder: false,
        colorOrder: false,
      }
    };
  },
  computed: {
    checkboxes() {
      return [
        { text: "投稿時間が新しい順に並び変える", value: "newOrder" },
        { text: "投稿時間が古い順に並び替える", value: "oldOrder" },
        { text: "投稿者順に並び変える", value: "whoOrder" },
        { text: "タグごと（色別）に並び変える", value: "colorOrder" },
        { text: "いいね数順に並び変える", value: "likeOrder" }
      ];
    },
    checkboxes1() {
      return [
        { text: "投稿時間が新しい順に並び変える", value: "newOrder" },
        { text: "投稿時間が古い順に並び替える", value: "oldOrder" },
        { text: "投稿者順に並び変える", value: "whoOrder" },
        { text: "タグごと（色別）に並び変える", value: "colorOrder" },
        { text: "いいね数順に並び変える", value: "likeOrder" },             
        { text: "重要度順に並び変える", value: "importanceOrder" },
      ];
    },
    idea_slider(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_slider) return this.$store.state.config.setting.idea_slider
      else return false
    },
  },
  methods: {
    getAddedLikeCount(id) {
      if (!this.modifiedLikesCounts.length) return 0
      return this.modifiedLikesCounts.find((d)=>d.ideaId==id)?.count ?? 0
    },
    say() {
      console.log("hello")
    },
    sortByData(sortIdeaList){
      sortIdeaList.sort(function(a,b){
        if(a.sort < b.sort) return 1;
        if(a.sort > b.sort) return -1;
        return 0;
      });
      return sortIdeaList;
    },
    onChange(name) {
      console.log("nameOOO",name)
      if (name=="newOrder"){
          let searchIdeaList = [];
          searchIdeaList = this.ideaList.sort(function(a,b){
              if(a.sort < b.sort) return 1;
              if(a.sort > b.sort) return -1;
              return 0;
              });
          //console.log("searchIdeaList",searchIdeaList);
          this.$emit('newshowedIdea', searchIdeaList);
      }
      else if (name=="oldOrder"){
          let searchIdeaList = [];
          searchIdeaList = this.ideaList.sort(function(a,b){
              if(a.sort > b.sort) return 1;
              if(a.sort < b.sort) return -1;
              return 0;
              });
          //console.log("searchIdeaList",searchIdeaList);
          this.$emit('newshowedIdea', searchIdeaList);
      }
      else if (name=="whoOrder"){
          let searchIdeaList = [];
          if(this.checkboxState[name]==true){
              searchIdeaList = this.ideaList.sort(function(a,b){
                  if(a.author > b.author) return 1;
                  if(a.author < b.author) return -1;
                  return 0;
                  });
          }else{
              searchIdeaList = this.ideaList.sort(function(a,b){
                  if(a.author < b.author) return 1;
                  if(a.author > b.author) return -1;
                  return 0;
                  });
          }
          //console.log("searchIdeaList",searchIdeaList);
          this.$emit('newshowedIdea', searchIdeaList);
      }
      else if (name=="colorOrder"){
        let searchIdeaList = [];
        if(this.checkboxState[name]==true){
          searchIdeaList = this.ideaList.sort(function(a,b){
            //console.log("a",a,b)
            if(a.postcolor > b.postcolor) return 1;
            if(a.postcolor < b.postcolor) return -1;
            return 0;
          });
        }else{
          searchIdeaList = this.ideaList.sort(function(a,b){
            if(a.postcolor < b.postcolor) return 1;
            if(a.postcolor > b.postcolor) return -1;
            return 0;
          });
        }
        searchIdeaList = searchIdeaList.filter((el)=>{
          return el.tag && el.tag.color && el.tag.color.length>1
        })
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
      }
      else if (name=="likeOrder"){
        let self = this
        let searchIdeaList = [];
        searchIdeaList = this.ideaList.sort(function(a,b){
          //console.log("a",a,b)
          if(a.like.length + self.getAddedLikeCount(a.id) < b.like.length + self.getAddedLikeCount(b.id)) return 1;
          if(a.like.length + self.getAddedLikeCount(a.id) > b.like.length + self.getAddedLikeCount(b.id)) return -1;
          return 0;
        });
        console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
      }
      else if (name=="importanceOrder"){
        let searchIdeaList = [];
        searchIdeaList = this.ideaList.sort(function(a,b){
          //console.log("a",a,b)
          if(!a.sliderNum) a.sliderNum = -1000
          if(!b.sliderNum) b.sliderNum = -1000
            
          if(a.sliderNum < b.sliderNum) return 1;
          if(a.sliderNum > b.sliderNum) return -1;            
          
          return 0;
        });
        console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
      }
      this.$emit("close",false)
    }
  }
};
</script>
<style scoped>
</style>